import { useSiteCountryCode } from '@common/hooks/localisation';

export function useGetCreateBusinessLink(shouldCreateJob = true) {
  const countryCode = useSiteCountryCode();

  return `/${countryCode}/businesses/create?shouldCreateJob=${shouldCreateJob}`;
}
